import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Drag-n-drop reorder for the model_page gallery on the admin example
// index. The controller wraps the cards container; each child card
// carries data-id (the example KSUID) so the new order can be POSTed
// to the reorder endpoint after a drag finishes.

export default class SortableExamplesController extends Controller<HTMLElement> {
  static values = {
    url: String,
  };

  declare readonly urlValue: string;

  sortable?: Sortable;

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-sortable-handle]",
      ghostClass: "opacity-40",
      onEnd: this.persistOrder.bind(this),
    });
  }

  disconnect() {
    this.sortable?.destroy();
    this.sortable = undefined;
  }

  private async persistOrder() {
    const order = Array.from(this.element.children)
      .map((el) => (el as HTMLElement).dataset.id)
      .filter((id): id is string => Boolean(id));

    if (order.length === 0) return;

    const token = document
      .querySelector<HTMLMetaElement>("meta[name='csrf-token']")
      ?.content ?? "";

    try {
      await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
          Accept: "application/json",
        },
        body: JSON.stringify({ order }),
        credentials: "same-origin",
      });
    } catch (err) {
      console.error("[sortable-examples] reorder request failed", err);
    }
  }
}
